<hvl-form-item [formGroup]="formGroup" label="{{ label | translate }}" key="{{ name }}">
    <p-dropdown uiKovanDropdown
        [id]="inputId"
        [name]="name"
        [formControlName]="name"
        class="form-control"
        [options]="options"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [filter]="true"
        [readonly]="readonly"
        (onChange)="onChangeEvent($event)"
        (ngModelChange)="ngModelChangeEvent($event)"
        [disabled]="disabled"
    >
    </p-dropdown>
</hvl-form-item>
